import React from 'react';
// UI
import { makeStyles } from '@material-ui/core/styles';
import {
  ClickAwayListener,
  Grow,
  Popper,
} from '@material-ui/core';
// UI - icons
import enterIco from '../assets/icons/enter-ico.svg';
import { BaseDivider } from 'src/components/common';
import { useDispatch } from 'react-redux';
import { openLoginModal } from 'src/store/layout/slice';

interface IUseStylesProp {
  openedNotificationsAnchorEl: boolean;
}

const useStyles = makeStyles((theme) => ({
  arrowIcon: {
    marginBottom: '-5.5px',
    cursor: 'pointer',
    transform: (props: IUseStylesProp) =>
      props.openedNotificationsAnchorEl ? 'rotate(180deg)' : 'rotate(0deg)',
    transition: '0.3s transform',
  },
  timerRow: {
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: 'auto 1fr',
    gridGap: '5px',
  },
  menuIco: {
    marginRight: '11px',
  },
  menu__link: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: 'black',
    cursor: 'pointer',
  },

  menu__link_active: {
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  card: {
    padding: '12px 0',
  },
  list: {
    padding: '5px',
    cursor: 'pointer'
  },
  listItem:{
    padding: '10px',
    background: "#fff",
    borderRadius: '4px',
    boxShadow: '0px 5px 18px rgba(108, 108, 108, 0.15)',
    margin: '5px 0 0'
  }
}));

export const LoginMenu:React.FC<any> = ({onLoginClick}) => {

  const [notificationsAnchorEl, setNotificationsAnchorEl] =
    React.useState<null | HTMLElement>(null);
    
  const handleNotificationsClick = (event: React.MouseEvent<HTMLElement>) => {
    setNotificationsAnchorEl(
      notificationsAnchorEl ? null : event.currentTarget,
    );
  };
  const openedNotificationsAnchorEl = Boolean(notificationsAnchorEl);
  const notificationsPopperId = openedNotificationsAnchorEl
    ? 'upcomingInterview'
    : undefined;

  const handleClickAway = (
    event: React.MouseEvent<Document, globalThis.MouseEvent>,
  ) => {
    if (event.target === notificationsAnchorEl) return;
    setNotificationsAnchorEl(null);
  };

  const classes = useStyles({
    openedNotificationsAnchorEl,
  });
  
  const dispatch = useDispatch();

  return (
    <div>

        <div className={classes.timerRow}>
          <div className={classes.menu__link} onClick={handleNotificationsClick}>
              <img src={enterIco} alt="Enter" className={classes.menuIco} />
              <span>Login</span>
          </div>
        </div>

      <Popper
        id={notificationsPopperId}
        open={openedNotificationsAnchorEl}
        anchorEl={notificationsAnchorEl}
        placement="bottom-start"
        style={{ zIndex: 100 }}
        transition>
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} timeout={300}>
            <div>
              <ClickAwayListener onClickAway={handleClickAway}>
                <div className={classes.listItem}>
                  <div 
                    className={classes.list}
                    onClick={() => dispatch(openLoginModal("Journalist"))}
                  >Login as a Journalist</div>
                  <BaseDivider mTop="8px" mBottom="8px" />
                  <div 
                    className={classes.list}
                    onClick={() => dispatch(openLoginModal("Expert"))}
                  >Login as an Expert</div>
                </div>
              </ClickAwayListener>
            </div>
          </Grow>
        )}
      </Popper>
    </div>
  );
};
